module.exports = __webpack_public_path__ + "img/reading-gnome.f9e0a28c.png";